import { render, staticRenderFns } from "./ProfilesChoose.vue?vue&type=template&id=174acc58&scoped=true"
import script from "./ProfilesChoose.vue?vue&type=script&lang=js"
export * from "./ProfilesChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174acc58",
  null
  
)

export default component.exports